// Derives the "Belum submit (dari target)" KPI card on the Ringkasan dashboard from the
// rows returned by GET /prodis/progress.
//
// Each row already excludes is_duplicate records from `submitted` (see backend
// get_prodi_progress), and carries `expected_count` (0 = admin has not set a target).
//
// The KPI is the total remaining shortfall across every prodi that HAS a target:
//   sum of max(0, expected_count - submitted)
// Prodis without a target are ignored entirely — there is nothing to measure against.
// Overshoot (submitted > target) never subtracts from the total.
//
// Returns null when not a single prodi has a target yet, so the card can show "–"
// instead of a misleading 0.
export function targetShortfall(progressRows) {
  const rows = Array.isArray(progressRows) ? progressRows : [];
  const withTarget = rows.filter((r) => Number(r?.expected_count) > 0);
  if (!withTarget.length) return null;
  return withTarget.reduce(
    (sum, r) => sum + Math.max(0, Number(r.expected_count) - Number(r.submitted || 0)),
    0
  );
}
